let previousQty = 0;

function getCurrentQty() {
  const inputs = document.querySelectorAll(
    'input[name="updates[]"], .quantity__input'
  );

  let totalQty = 0;

  inputs.forEach((input) => {
    totalQty += parseInt(input.value) || 0;
  });

  return totalQty;
}

function refreshCartSections() {
  fetch('/?sections=cart-drawer,main-cart-footer,cart-icon-bubble')
    .then((res) => res.json())
    .then((data) => {
      const parser = new DOMParser();

      // CART DRAWER
      if (data['cart-drawer']) {
        const drawerHTML = parser.parseFromString(
          data['cart-drawer'],
          'text/html'
        );

        const newDrawerFooter =
          drawerHTML.querySelector('.cart-drawer__footer');

        const currentDrawerFooter =
          document.querySelector('.cart-drawer__footer');

        if (newDrawerFooter && currentDrawerFooter) {
          currentDrawerFooter.style.opacity = '0.6';
          currentDrawerFooter.innerHTML = newDrawerFooter.innerHTML;
          currentDrawerFooter.style.opacity = '1';
        }
      }

      // CART PAGE
      if (data['main-cart-footer']) {
        const cartHTML = parser.parseFromString(
          data['main-cart-footer'],
          'text/html'
        );

        const newCartFooter =
          cartHTML.querySelector('.cart__footer');

        const currentCartFooter =
          document.querySelector('.cart__footer');

        if (newCartFooter && currentCartFooter) {
          currentCartFooter.style.opacity = '0.6';
          currentCartFooter.innerHTML = newCartFooter.innerHTML;
          currentCartFooter.style.opacity = '1';
        }
      }

      // CART ICON
      if (data['cart-icon-bubble']) {
        const iconHTML = parser.parseFromString(
          data['cart-icon-bubble'],
          'text/html'
        );

        const newIcon =
          iconHTML.querySelector('#cart-icon-bubble');

        const currentIcon =
          document.querySelector('#cart-icon-bubble');

        if (newIcon && currentIcon) {
          currentIcon.innerHTML = newIcon.innerHTML;
        }
      }
    })
    .catch((err) => {
      console.error('Cart refresh error:', err);
    });
}

function initCartTierRefresh() {
  previousQty = getCurrentQty();
}

document.addEventListener('DOMContentLoaded', initCartTierRefresh);

document.addEventListener('change', function (e) {
  const target = e.target;

  if (
    target.name === 'updates[]' ||
    target.classList.contains('quantity__input')
  ) {
    setTimeout(() => {
      const totalQty = getCurrentQty();

      const crossedTier =
        (previousQty < 3 && totalQty >= 3) ||
        (previousQty >= 3 && totalQty < 3) ||
        (previousQty < 6 && totalQty >= 6) ||
        (previousQty >= 6 && totalQty < 6);

      if (!crossedTier) {
        previousQty = totalQty;
        return;
      }

      refreshCartSections();

      previousQty = totalQty;
    }, 400);
  }
});